import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const MegaphoneLoudIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={128}
      height={128}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.711 84.4657L32.823 92.3476C34.3782 98.1517 40.3441 101.596 46.1482 100.041C51.9523 98.4858 55.3967 92.5198 53.8415 86.7157L53.5386 85.5854M29.032 59.2141L70.809 27.1336C73.372 25.1655 77.1125 26.4345 77.9489 29.5559L92.7392 84.7542C93.5756 87.8756 90.9708 90.8448 87.767 90.4218L35.5468 83.5278C34.9561 83.4498 34.3557 83.4891 33.7802 83.6433L16.6987 88.2203C14.2803 88.8683 11.7945 87.4331 11.1465 85.0147L7.15721 70.1266C6.50921 67.7082 7.94438 65.2224 10.3628 64.5744L27.4443 59.9974C28.0198 59.8432 28.5594 59.577 29.032 59.2141Z"
        stroke={strokeColor}
        strokeWidth={4}
      />
      <path
        d="M102.651 71.5429C109.554 59.5856 105.457 44.2959 93.5 37.3923M113.043 77.5429C123.26 59.8461 117.197 37.2173 99.5 27"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={4}
      />
    </svg>
  );
};
